<ng-template #createResearchProjectModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Create Research Project</h5>
    <button type="button" class="btn-close" (click)="closeModal()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="form">
      <div class="mb-3">
        <label class="form-label">Project Name <span class="text-danger">*</span></label>
        <input type="text" class="form-control" formControlName="name"
          [ngClass]="{ 'is-invalid': submitted && form.controls['name'].errors }">
        @if (submitted && form.controls['name'].errors) {
          <div class="invalid-feedback">Project name is required</div>
        }
      </div>
      <div class="mb-3">
        <label class="form-label">Description</label>
        <textarea class="form-control" formControlName="description" rows="3"></textarea>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="closeModal()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="spinner">
      @if (spinner) { <span class="spinner-border spinner-border-sm me-1"></span> }
      Create Project
    </button>
  </div>
</ng-template>
